<template>
  <ADialog
    :visible="copiedVisibleTrigger"
    :top="top"
    :width="dialogWidth"
    :custom-class="customClass"
    :close="showClose"
    :show-close="showClose"
    :hide-single-button="hideSingleButton"
    :hide-double-button="hideDoubleButton"
    :single-text="singleText"
    :hide-header-trigger="hideHeaderTrigger"
    @click-close="() => $emit('close-dialog')"
    @click-single-button="() => $emit('click-single-button')"
  >
    <p class="single-button-dialog-title flex flex-align-center pb-8">
      {{ dialogTitle }}
    </p>
    <p class="single-button-dialog-description flex flex-align-center">
      {{ dialogDescription }}
    </p>
    <slot />
  </ADialog>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    top?: string
    dialogWidth?: string
    customClass?: string
    showClose?: boolean
    closeModal?: boolean
    dialogVisibleTrigger?: boolean
    hideSingleButton?: boolean
    hideDoubleButton?: boolean
    dialogTitle?: string
    dialogDescription?: string
    singleText?: string
    hideHeaderTrigger?: boolean
  }>(),
  {
    top: '20vh',
    dialogWidth: '296px',
    customClass: 'single-button-dialog',
    showClose: false,
    closeModal: true,
    dialogVisibleTrigger: false,
    hideSingleButton: false,
    hideDoubleButton: true,
    dialogTitle: '',
    dialogDescription: '',
    singleText: '',
    hideHeaderTrigger: false
  }
)

const emits = defineEmits(['close-dialog', 'click-single-button'])

const copiedVisibleTrigger = ref(false)

watch(
  () => props.dialogVisibleTrigger,
  (newValue) => {
    copiedVisibleTrigger.value = newValue
  }
)

watch(
  () => copiedVisibleTrigger.value,
  (newValue) => {
    if (!newValue) {
      emits('close-dialog')
    }
  }
)
</script>
